import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AlertBannerService, AlertType } from '../../lib/alert-banner';
import { parseSetupKeyFromProvisioningUri } from './authenticator-modal.utils';

@Component({
  selector: 'app-authenticator-modal',
  templateUrl: './authenticator-modal.component.pug',
  styleUrl: './authenticator-modal.component.scss',
  standalone: false
})
export class AuthenticatorModalComponent implements OnChanges {
  @Input() qrCodeData: string = '';
  @Output() verified = new EventEmitter<{ code: string }>();

  verificationCode: string = '';
  manualSetupKey: string = '';
  showManualKey = false;
  isLoading: boolean = false;
  errorFeedback: boolean = false;
  errors = [
    {
      name: 'invalidCode',
      msg: $localize`The code is incorrect or has expired, please try again.`,
      enabled: false
    }
  ];

  constructor(
    public _bsModalRef: BsModalRef,
    private alertList: AlertBannerService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['qrCodeData']) {
      this.manualSetupKey = parseSetupKeyFromProvisioningUri(this.qrCodeData);
      this.showManualKey = false;
    }
  }

  cancel(): void {
    this._bsModalRef.hide();
  }

  verify(): void {
    if (!this.verificationCode || this.verificationCode.length < 6 || this.isLoading) {
      return;
    }
    this.resetError();
    this.isLoading = true;
    this.verified.emit({ code: this.verificationCode });
  }

  toggleManualKey(): void {
    this.showManualKey = !this.showManualKey;
  }

  copySetupKey(): void {
    if (!this.manualSetupKey || !navigator?.clipboard) {
      return;
    }

    navigator.clipboard.writeText(this.manualSetupKey).then(() => {
      this.alertList.append([{
        type: AlertType.SUCCESS,
        message: $localize`Setup key copied to clipboard.`,
        keepOnRouteChange: true,
      }]);
    });
  }

  textValueChanged(value: string): void {
    const digitsOnly = (value || '').replace(/\D/g, '').slice(0, 6);
    this.verificationCode = digitsOnly;
    if (this.errorFeedback) {
      this.resetError();
    }
  }

  setError(): void {
    this.isLoading = false;
    this.errorFeedback = true;
    this.errors = this.errors.map((e) => ({ ...e, enabled: e.name === 'invalidCode' }));
  }

  resetError(): void {
    this.errorFeedback = false;
    this.errors = this.errors.map((e) => ({ ...e, enabled: false }));
  }

  closeModal(): void {
    this.isLoading = false;
    this._bsModalRef.hide();
  }
}
